<template>
  <s-button
    v-bind="$attrs"
    @click="$router.back()"
    id="ButtonCancel"
    :dark="true"
    :flat="true"
    class="underline"
    >{{ $t('generic.back') }}</s-button
  >
</template>

<script>
export default {
  mounted() {}
};
</script>

<style></style>
